// Add your custom JS here.

// Import slick-carousel
import 'slick-carousel/slick/slick.min.js';
jQuery(function($) {
    $('.news-carousel').slick({
        infinite: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.2,
                }
            }
        ]
    });
});

/*jQuery(function($) {
    $('.category-grid-3_small .post-carousel').slick({
        infinite: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2.2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.2,
                }
            }
        ]
    });
});*/


jQuery(function($) {
    $('.post-carousel').each(function() {
        var $carousel = $(this);
        var itemsToShow = $carousel.data('items') || 3;

        $carousel.slick({
            infinite: false,
            arrows: true,
            dots: false,
            slidesToShow: itemsToShow,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3.2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2.2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1.2,
                    }
                }
            ]
        });
    });
});




// search button in navigation
document.addEventListener('DOMContentLoaded', function() {
    const searchToggle = document.querySelector('.search-toggle');
    const searchOverlay = document.getElementById('searchOverlay');
    const searchClose = document.querySelector('.search-close');
    const navbar = document.getElementById('main-nav');

    if (searchToggle && searchOverlay) {
        searchToggle.addEventListener('click', function(e) {
            e.preventDefault();
            searchOverlay.classList.add('active');
            navbar.classList.add('active-search');
            // document.body.style.overflow = 'hidden';

            setTimeout(() => {
                const searchInput = searchOverlay.querySelector('input[type="search"]');
                if (searchInput) searchInput.focus();
            }, 300);
        });

        if (searchClose) {
            searchClose.addEventListener('click', function(e) {
                e.preventDefault();
                closeSearch();
            });
        }

        searchOverlay.addEventListener('click', function(e) {
            if (e.target === searchOverlay) {
                closeSearch();
            }
        });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
                closeSearch();
            }
        });

        function closeSearch() {
            searchOverlay.classList.remove('active');
            navbar.classList.remove('active-search');
            // document.body.style.overflow = '';
        }
    }
});

// Navbar scroll effect
window.addEventListener('scroll', function() {
    const navbar = document.getElementById('main-nav');

    if (navbar) {
        if (window.scrollY > 50) {
            navbar.classList.add('scrolled');
        } else {
            navbar.classList.remove('scrolled');
        }
    }
});



/* Enables clickable parent links in dropdown menus on desktop devices (>992px) */
jQuery(document).ready(function($) {
    if ($(window).width() > 992) {
        $('.navbar .dropdown > a').on('click', function(e) {
            if (this.href && this.href !== '#') {
                window.location.href = this.href;
            }
        });
        $('.navbar .dropdown > a').removeAttr('data-toggle').removeAttr('data-bs-toggle');
    }
});
